import CollapseQuestion   from 'components/Site/NewLanding/UI/CollapseQuestion';
import styles             from './paq-view.module.scss';
import { useTranslation } from 'next-i18next';

const FAQView = () => {
  const { t } = useTranslation('landing');

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <h1 className="page-title">FAQ</h1>
        <div className="page-description">
          <p>
            {t('pages.faq.description_1')}
          </p>
          <p>
            {t('pages.faq.description_2')}
          </p>
        </div>

        <div className={styles.content_container}>
          <CollapseQuestion
            question={t('pages.faq.questions_1')}
            answer={t('pages.faq.answer_1')}
          />
          <CollapseQuestion
            question={t('pages.faq.questions_2')}
            answer={t('pages.faq.answer_2')}
          />
          <CollapseQuestion
            question={t('pages.faq.questions_3')}
            answer={t('pages.faq.answer_3')}
          />
          <CollapseQuestion
            question={t('pages.faq.questions_4')}
            answer={t('pages.faq.answer_4')}
          />
          <CollapseQuestion
            question={t('pages.faq.questions_5')}
            answer={t('pages.faq.answer_5')}
          />
        </div>
      </div>
    </div>
  )
}

export default FAQView;